import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type ThumbnailUrl_AudioAsset_Fragment = { __typename?: 'AudioAsset', thumbnailImageUrl?: { __typename?: 'ImageTranscodeUrl', url: string } | null };

export type ThumbnailUrl_DocumentAsset_Fragment = { __typename?: 'DocumentAsset', thumbnailImageUrl?: { __typename?: 'ImageTranscodeUrl', url: string } | null };

export type ThumbnailUrl_FileAsset_Fragment = { __typename?: 'FileAsset' };

export type ThumbnailUrl_FolderAsset_Fragment = { __typename?: 'FolderAsset' };

export type ThumbnailUrl_ImageAsset_Fragment = { __typename?: 'ImageAsset', thumbnailImageUrl?: { __typename?: 'ImageTranscodeUrl', url: string } | null };

export type ThumbnailUrl_InteractiveAsset_Fragment = { __typename?: 'InteractiveAsset', thumbnailImageUrl?: { __typename?: 'ImageTranscodeUrl', url: string } | null };

export type ThumbnailUrl_InteractiveLiveAsset_Fragment = { __typename?: 'InteractiveLiveAsset' };

export type ThumbnailUrl_ModelAsset_Fragment = { __typename?: 'ModelAsset', thumbnailImageUrl?: { __typename?: 'ImageTranscodeUrl', url: string } | null };

export type ThumbnailUrl_UnsupportedAsset_Fragment = { __typename?: 'UnsupportedAsset' };

export type ThumbnailUrl_VersionStackAsset_Fragment = { __typename?: 'VersionStackAsset' };

export type ThumbnailUrl_VideoAsset_Fragment = { __typename?: 'VideoAsset', thumbnailImageUrl?: { __typename?: 'ImageTranscodeUrl', url: string } | null };

export type ThumbnailUrlFragment = ThumbnailUrl_AudioAsset_Fragment | ThumbnailUrl_DocumentAsset_Fragment | ThumbnailUrl_FileAsset_Fragment | ThumbnailUrl_FolderAsset_Fragment | ThumbnailUrl_ImageAsset_Fragment | ThumbnailUrl_InteractiveAsset_Fragment | ThumbnailUrl_InteractiveLiveAsset_Fragment | ThumbnailUrl_ModelAsset_Fragment | ThumbnailUrl_UnsupportedAsset_Fragment | ThumbnailUrl_VersionStackAsset_Fragment | ThumbnailUrl_VideoAsset_Fragment;

export const ThumbnailUrl = /*#__PURE__*/ gql`
    fragment ThumbnailUrl on Asset {
  ... on AudioAsset {
    thumbnailImageUrl {
      url
    }
  }
  ... on DocumentAsset {
    thumbnailImageUrl {
      url
    }
  }
  ... on ImageAsset {
    thumbnailImageUrl {
      url
    }
  }
  ... on InteractiveAsset {
    thumbnailImageUrl {
      url
    }
  }
  ... on VideoAsset {
    thumbnailImageUrl {
      url
    }
  }
  ... on ModelAsset {
    thumbnailImageUrl {
      url
    }
  }
}
    ` as unknown as DocumentNode<ThumbnailUrlFragment, unknown>;

        

        
export const useThumbnailUrlFragment = (
  input: string | Omit<UseFragmentOptions<ThumbnailUrlFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Asset' } };
    return input;
  })();

  return useFragment<ThumbnailUrlFragment>({
    fragment: ThumbnailUrl,
    fragmentName: 'ThumbnailUrl',
    ...options,
  });
};
  
        